import { render, staticRenderFns } from "./downstreamPaymentDetail_old.vue?vue&type=template&id=195f165d&scoped=true"
import script from "./downstreamPaymentDetail_old.vue?vue&type=script&lang=js"
export * from "./downstreamPaymentDetail_old.vue?vue&type=script&lang=js"
import style0 from "./downstreamPaymentDetail_old.vue?vue&type=style&index=0&id=195f165d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f165d",
  null
  
)

export default component.exports